module.exports = __webpack_public_path__ + "media/images/redesign-images/home/utees-life-2-022c42c73294d7e40cee6a825658cf9e.jpg";